<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>
    Select Asset {{ (dataSource.parent_id ? 'Subtype' : 'Type') + (data['multiple'] ? 's' : '') }}
    <span>
      ({{ dataSource.selection.selected.length }})
    </span>
  </h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <button
    mat-raised-button
    color="primary"
    type="button"
    class="m-1 mr-2"
    (click)="onCreate()"
    *ngIf="app.isAuthenticated && app.userAccountLink.permissions != 'Employee' && data['can_create']">
    <mat-icon>add</mat-icon> New Asset {{ dataSource.parent_id ? 'Subtype' : 'Type' }}
  </button>

  <form class="form-inline my-auto my-lg-0 float-lg-right" (ngSubmit)="dataSource.getData(true)">
    <button mat-raised-button class="mr-2 mr-lg-3 my-1" type="button" *ngIf="dataSource.parent_id" (click)="onResetList()">
      <mat-icon>arrow_back</mat-icon> Asset Types
    </button>

    <input
      class="form-control mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search"
      aria-label="Search" />

    <button mat-raised-button color="secondary" class="mr-2 mr-lg-3 my-1" type="submit">
      <mat-icon>search</mat-icon> Search
    </button>

    <button mat-raised-button class="mr-2 my-1" (click)="onClearSelected()" type="button">
      Clear Selected
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="id"
    matSortDirection="asc"
    matSortDisableClear>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
          *ngIf="dataSource.multiple">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="onAssetTypeSelectionChange($event.checked, row)"
          [checked]="dataSource.selection.isSelected(row.id)"
          appMarginRight>
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'Toggle sorting by the id of the asset ' + (dataSource.parent_id ? 'subtype.' : 'type.')">#</th>
      <td mat-cell *matCellDef="let element" class="text-wrap">
        {{ element.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'Toggle sorting by the name of the asset ' + (dataSource.parent_id ? 'subtype.' : 'type.')" [style.width.px]="300">Name</th>
      <td mat-cell *matCellDef="let asset_type" class="text-wrap">
        <ng-container *ngIf="asset_type?.parent">
          <small style="display: block;">{{ asset_type?.parent?.name }}</small>
        </ng-container>
        <mat-icon *ngIf="asset_type?.parent_id" style="font-size: 16px;">subdirectory_arrow_right</mat-icon>
        {{ asset_type.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef class="no-padding" [style.width.px]="400">
        Description
      </th>
      <td mat-cell *matCellDef="let asset_type" class="no-padding text-wrap">
        {{ asset_type.description | ellipsis: ['100'] }}
      </td>
    </ng-container>

    <ng-container matColumnDef="linked_assets_count">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Linked Assets Count
      </th>
      <td mat-cell *matCellDef="let asset_type" class="no-padding text-wrap">
        <span *ngIf="!dataSource.parent_id">{{ asset_type?.total_linked_assets_count ?? 0 }}</span>
        <span *ngIf="dataSource.parent_id">{{ asset_type?.linked_assets_count ?? 0 }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_by_user">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header [matTooltip]="'Toggle sorting by the user that created the asset ' + (dataSource.parent_id ? 'subtype.' : 'type.')">
        Created By
      </th>
      <td mat-cell *matCellDef="let asset_type" class="no-padding text-wrap">
          <span *ngIf="asset_type?.created_by_user else showSystemCreator">
            <a (click)="$event.stopPropagation(); onUserPublicView(asset_type.created_by_user.hash)" matTooltip="View User Public Profile">
              {{ asset_type.created_by_user.contact_person }}
            </a>
          </span>
        <ng-template #showSystemCreator>System</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header [matTooltip]="'Toggle sorting by the created at date of the asset ' + (dataSource.parent_id ? 'subtype.' : 'type.')">
        Created At
      </th>
      <td mat-cell *matCellDef="let asset_subtype" class="no-padding">
        {{ (asset_subtype.date_created * 1000) | timezoneConvertMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        Actions
      </th>
      <td mat-cell *matCellDef="let asset_type">
        <button type="button" mat-button (click)="$event.stopPropagation(); onFilterByParent(asset_type.id)" matTooltip="Show Asset Subtypes." matTooltipPosition="above" >
          Subtypes ({{ asset_type.children_count }}) <mat-icon>chevron_right</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onAssetTypeRowClick(row)"></tr>
  </table>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
  <mat-paginator
    class="my-2 ml-1 mr-2"
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>

  <button
    class="my-2 mx-1"
    mat-raised-button
    color="primary"
    type="button"
    (click)="onSaveAndClose()"
    [disabled]="data['required'] && !dataSource.selection.hasValue()">
    Select & Close
  </button>
</mat-dialog-actions>
